'use strict';
var collection = require('../internals/collection');
var collectionStrong = require('../internals/collection-strong');

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/modules/es.set.js
// module id = 1752
// module chunks = 1